import React from 'react';
import UI from '../ui';
import Utils from '../utils';
import Auth0Util from '../utils/Auth0Util';
import Util from '../utils/Util';

const { Session } = Utils;
const { WrappedButton, WrappedButtonType, Link } = UI;

export const LoginError = ({ responsiveCls, SSOError }) => {
	const onClickReturnToLogin = () => {
		// In some cases, the error may be due to the sera endpoint in accountapi not being available
		// trigger signout to clear the session and redirect to login
		Auth0Util.signOut();
	};

	return (
		<div className="common-authentication auth-login-error-view">
			<div className="form">
				<div className="primary-header">Login Error</div>
				<div className="error">
					<span className="error-icon" />
					<span className="error-message">
						We were unable to process your request. Please return to the login
						page and try again.
					</span>
				</div>
				<div className="contact-support">
					<p>
						Having trouble logging in? Contact our Support team.
						<br />
						<Link to="tel:877-782-6780" dataqa="login-support-phone-link">
							877-782-6780
						</Link>{' '}
						or{' '}
						<Link
							to="mailto:loginsupport@stamps.com"
							dataqa="login-support-email-link"
						>
							loginsupport@stamps.com
						</Link>
						.
					</p>
				</div>
				<div className="row-container centered">
					<WrappedButton
						label="Return to login"
						buttonType={WrappedButtonType.Primary}
						dataqa="return-to-login-error"
						onClick={onClickReturnToLogin}
					/>
				</div>
			</div>
		</div>
	);
};
